import LinearProgress from '@zenbusiness/zui/LinearProgress';
import superstyled from '@zenbusiness/zui/styles/superstyled';

export const StyledLinearProgress = superstyled({
  name: 'LinearProgress',
  slot: 'Root',
  tag: LinearProgress,
  styles: ({ theme, height = 2 }) => ({
    // Height is in px. 2 for default for divider and 10 for progress bar
    height: `${height}px`,
    borderRadius: 5,
    background: theme.palette.background.grey.dark,
    '& .MuiLinearProgress-bar': {
      background: `linear-gradient(225deg, ${theme.palette.secondary.main} 0%, ${theme.palette.background.blue.main} 100%)`
    }
  })
});
